
import React from 'react';
import { ChevronRight, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { CONTACT_INFO } from '../../constants/data';

export const HeroSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <header className="relative bg-white overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 to-blue-50/50 z-0"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-24 relative z-10">
        <div className="text-center max-w-4xl mx-auto">

          <Badge variant="status">
            {t('hero.badge')}
          </Badge>

          <h1 className="text-4xl md:text-6xl font-extrabold text-slate-900 tracking-tight mb-6 leading-tight">
            {t('hero.title_prefix')}{' '}
            <span className="text-blue-600">{t('hero.title_highlight')}</span>
          </h1>

          <p className="mt-4 max-w-2xl mx-auto text-xl text-slate-600 leading-relaxed">
            {t('hero.subtitle')}
          </p>

          <div className="mt-10 flex justify-center gap-4 flex-col sm:flex-row">
            <Button
              href="#contacto"
              variant="primary"
              icon={<ChevronRight size={20} />}
            >
              {t('hero.cta_quote')}
            </Button>

            <Button
              href={CONTACT_INFO.portfolioUrl}
              variant="secondary"
              target="_blank"
              rel="noopener noreferrer"
              icon={<ExternalLink size={18} />}
            >
              {t('hero.cta_portfolio')}
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

